import { Button } from '@mui/material';
import  styled from 'styled-components';

export const SButton = styled(Button)`
  cursor: pointer;
`;
